import styled from 'styled-components';

export const Avatar = styled.div`
  width: 24px;
  height: 24px;
  border: 1px solid transparent;
  background: linear-gradient(90deg, #007bff, #009f79) padding-box,
    linear-gradient(90deg, #007bff, #009f79) border-box;

  border-radius: 4px;
  font-size: 16px;
  font-weight: lighter;
  color: white;
  text-align: center;
`;

export const Button = styled.button`
  font-size: 0.8rem;
  text-decoration: underline;
`;
